import React, {useState} from 'react';
import { Grid, FormControl, InputLabel, Select } from '@material-ui/core';
import SearchableTable from '../components/SearchableTableV2';
import Content from '../components/Content';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

const options = [
	'Create',
	'Back'
  ];
  
const ITEM_HEIGHT = 48;

const useStyles = makeStyles((theme) => ({
	root: {
	  width: '100%',
	},
	heading: {
	  fontSize: theme.typography.pxToRem(15),
	  fontWeight: theme.typography.fontWeightRegular,
	},
  }));

const FamasDetails = () => {
	const classes = useStyles();
	const history = useHistory();
	const [searchCriteria, setSearchCriteria] = useState('header');

	const [rowsToPush, setRowsToPush] = useState([]);
	const [selectedRawEdit, setSelectedRawEdit] = useState({});
	const [anchorEl, setAnchorEl] = React.useState(null);
  	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		console.log(e.target.textContent);
		switch(e.target.textContent){
			case 'Create':
				history.push({pathname: '/famas/create'});
				break;
			case 'Back':
				history.goBack();
				break;
			default:
		}
		
		setAnchorEl(null);
	};

	const handleChange = (event) => {

	}

	const handleChangeCriteria = (e) => {
		setSearchCriteria(e.target.value);
	}

	const getYearList = () =>{

	}

	return (
		<Content>
			<div>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
					onClick={handleClick}
				>
					<MoreVertIcon />
				</IconButton>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
				
				>
					<span>FAMAS </span>
				</IconButton>
				
				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 5,
						width: '20ch',
					},
					}}
				>
					{options.map((option) => (
					<MenuItem key={option} selected={option === 'Pyxis'} onClick={(e)=>handleClose(e)}>
						{option}
					</MenuItem>
					))}
				</Menu>
			</div>
				
				<Grid item xs={12} md={12}>

				<SearchableTable
					table = {"famas/header/headersearch"}

					filterTable = "depts/organization"
					 
					defaultSortColumn = "idMaster"
				
					keyIdentifier = "idMaster"

					filters = { true }
					
					filterQuery
					
					enableFormEdit = { true }
				
					enableRawEdit = { false }

					selectedRawEdit = { [selectedRawEdit] }

					enableSelect = { false }

					useDataRowsFromParent = { false }

					queryId="famasHeaderQuery"

					displayedHeaders={[
						{
							key: 'toUserNames',
							displayedHeader: 'Assignee',
							displayedLength: 80,
							withList: false,
						},
						{
							key: 'docNo',
							displayedHeader: 'Document Number',
							displayedLength: 80,
							withList: false,
						},
						{
							key: 'assetTag',
							displayedHeader: 'Asset Tag',
							displayedLength: 80,
							withList: false,
						},
						{
							key: 'assetDesc',
							displayedHeader: 'Asset Description',
							displayedLength: 80,
							withList: false,
						},
						{
							key: 'companyName',
							displayedHeader: 'Business Unit',
							displayedLength: 80,
							withList: true,
							readOnly: false,

							listPath: 'company'
						},
						{
							key: 'organization',
							displayedHeader: 'Organization',
							displayedLength: 50,
							withList: true,
							readOnly: false,

							listPath: 'depts/organization',
							staticListKey: 'organization',
						},
						{
							key: 'approvalStatus',
							displayedHeader: 'Approval Status',
							displayedLength: 50,
							withList: true,
							readOnly: true,
							staticListKey: 'approvalStatus',
							staticList: ['For Approval', 'For TL Approval','Returned', 'Approved']
						}
						
					]}

					displayRows = {[
						{ key: 'idMaster', displayedHeader: 'ID', type: 'id' },
						{
							key: 'docNo',
							displayedHeader: 'Document Number',
							displayedLength: 50,
						},
						{
							key: 'fromUserName',
							displayedHeader: 'Created By',
							displayedLength: 50,
						},
						{
							key: 'toUserNames',
							displayedHeader: 'Assignee',
							displayedLength: 50,
						},
						{
							key: 'approvalStatus',
							displayedHeader: 'Approval Status',
							displayedLength: 50,
						},
						{
							key: 'assetTag',
							displayedHeader: 'Asset Tag',
							displayedLength: 50,
						},
						{
							key: 'assetDesc',
							displayedHeader: 'Asset Description',
							displayedLength: 100,
						},
						{
							key: 'serialNo',
							displayedHeader: 'Serial Number',
							displayedLength: 50,
						},
						{
							key: 'acqDate',
							displayedHeader: 'Acquisition Date',
							displayedLength: 50,
						}
					]}
				/>
				</Grid>
				
			
			

			
			
		</Content>
	);
};

export default FamasDetails;
